import moment from "moment-business-days";
import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

import "./App.css";

function App() {

  const [selectedDate, setSelectedDate] = useState(null);
  const [serviceDays, setServiceDays] = useState(2);
  const [serviceEndDate, setServiceEndDate] = useState(null);

  useEffect(() => {
    updateSelectedDate(selectedDate);
  }, [serviceDays]);

  const tileClassName = ({ date, view }) => {
    if (view === "month" && selectedDate) {
      if (date >= selectedDate && date <= serviceEndDate) {
        if (date.getDay() === 6 || date.getDay() === 0) {
          return;
        }

        return "serviceDaysClass";
      }

      if (
        date.getTime() ===
        moment(serviceEndDate).businessAdd(1, "day").toDate().getTime()
      ) {
        return "shippedClass";
      }
    }
  };

  const disableWeekends = ({ date }) => {
    return date.getDay() === 6 || date.getDay() === 0;
  };

  const updateSelectedDate = (date) => {
    setSelectedDate(date);
    const endDate =
      serviceDays === 2
        ? moment(date).businessAdd(serviceDays, "days")
        : moment(date).add(serviceDays, "days");
    setServiceEndDate(endDate.toDate());
  };

  return (
    <div className="App">
      <p>Select A Service Plan</p>
      <div className="serviceDays-container">
        <button
          className={serviceDays === 2 && "selected"}
          onClick={() => setServiceDays(2)}
        >
          First Class
        </button>
        <button
          className={
            serviceDays === 14 ? "selected dealer-only" : "dealer-only"
          }
          onClick={() => setServiceDays(14)}
        >
          Priority
        </button>
        <button
          className={serviceDays === 31 && "selected"}
          onClick={() => setServiceDays(31)}
        >
          Rush
        </button>
        <button
          className={serviceDays === 93 && "selected"}
          onClick={() => setServiceDays(93)}
        >
          Standard
        </button>
        {/* <button
          className={serviceDays === 186 && "selected"}
          onClick={() => setServiceDays(186)}
        >
          Value
        </button> */}
      </div>
      <Calendar
        value={selectedDate}
        onChange={updateSelectedDate}
        calendarType="US"
        tileDisabled={disableWeekends}
        tileClassName={tileClassName}
      />
    </div>
  );
}

export default App;
